<template>
  <div class="plugin-wrapper"></div>
</template>

<script>
export default {
  name: "MultiImageIcon"
}
</script>

<style lang="scss" scoped>

</style>